<label (mousedown)="question.onMouseDown()" [class]="question.getItemClass(row, column)">
  <input
    [type]="question.checkType"
    [class]="question.cssItemValue"
    [name]="row.fullName"
    [value]="column.value"
    [checked]="row.isChecked(column)"
    [readonly]="row.isReadOnlyAttr"
    [disabled]="row.isDisabledAttr"
    [attr.id]="question.inputId + '_' + row.name + '_' + columnIndex"
    (change)="onChange()"
    [attr.aria-required]="question.a11y_input_ariaRequired"
    [attr.aria-label]="question.getCellAriaLabel(row, column)"
    [attr.aria-invalid]="question.a11y_input_ariaInvalid"
    [attr.aria-errormessage]="question.a11y_input_ariaErrormessage"
  />
  <span [class]="question.cssMaterialDecorator">
    <svg *ngIf="itemSvgIcon" [class]="question.cssItemDecorator">
      <use [attr.xlink:href]="itemSvgIcon"></use>
    </svg> 
  </span>
  <span *ngIf="question.isMobile" [class]="question.cssClasses.cellResponsiveTitle" [model]="column.locText" sv-ng-string></span>
</label>
<ng-content></ng-content>